import React from 'react';
import FacebookIcon from 'react-icons/lib/io/social-facebook';
import YoutubeIcon from 'react-icons/lib/io/social-youtube';
import InstaIcon from 'react-icons/lib/io/social-instagram';
import TwitterIcon from 'react-icons/lib/io/social-twitter';
import Phone from 'react-icons/lib/io/ios-telephone';
import Email from 'react-icons/lib/io/ios-email';
import './Nav.css';

const UpperInfo =()=>{
    return(
            <ul className="upper-info wrapper clearfix">
                <li className="social"> <a href="https://www.facebook.com/Elmuhandis-Auto-138797603583040/">
                <span className="icon-wrapper"><FacebookIcon/></span></a>
                <a href="https://www.facebook.com/Elmuhandis-Auto-138797603583040/">
                <span className="icon-wrapper"><InstaIcon/></span></a>
                <a href="https://www.facebook.com/Elmuhandis-Auto-138797603583040/">
                <span className="icon-wrapper"><TwitterIcon/></span></a>
                <a href="https://www.facebook.com/Elmuhandis-Auto-138797603583040/">
                <span className="icon-wrapper"><YoutubeIcon/></span></a>
                </li>
                <li className="contact"><span className="icon-wrapper"><Phone/></span> <span className="-font">01222811311</span> </li>
                <li className="contact"><span className="icon-wrapper"><Email/></span> <span className="-font">elmuhandisauto@gmail.com</span></li>
            </ul>
    );
}
export default UpperInfo;


// WEBPACK FOOTER //
// ./src/components/nav/UpperInfo.js